/* Campaign attribution for storefront -> designer and B2B intake, 2026-10-20. */
(function () {
  'use strict';
  if (window.saunamoCampaignTracking) return;
  var STORE = 'saunamo_campaign_attribution_v1';
  var KEYS = ['gclid','gbraid','wbraid','gclsrc','gad_source','gad_campaignid','fbclid','utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term'];
  function cookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) { return null; }
  }
  function blocked() {
    return navigator.globalPrivacyControl === true || navigator.doNotTrack === '1';
  }
  function allowed() {
    if (blocked()) return false;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      var choice = privacy && privacy.currentVisitorConsent && privacy.currentVisitorConsent();
      if (choice && choice.marketing === 'no') return false;
      if (choice && choice.marketing === 'yes') return true;
      var own = cookie('saunamo_consent');
      if (own === 'denied') return false;
      if (own === 'granted') return true;
      return !!(privacy && privacy.marketingAllowed && privacy.marketingAllowed() === true);
    } catch (_) { return false; }
  }
  function clean(input) {
    var out = {};
    KEYS.forEach(function (key) {
      var value = input && input[key];
      if (typeof value === 'string' && value.length > 0 && value.length <= 512 && !/[\r\n<>@]/.test(value)) out[key] = value;
    });
    return out;
  }
  function read() {
    if (!allowed()) {
      try { sessionStorage.removeItem(STORE); } catch (_) {}
      return {};
    }
    var params = new URLSearchParams(location.search), incoming = {}, saved = {};
    KEYS.forEach(function (key) { incoming[key] = params.get(key); });
    incoming = clean(incoming);
    try { saved = clean(JSON.parse(sessionStorage.getItem(STORE) || '{}')); } catch (_) {}
    // A new campaign replaces the prior touch; never combine an old Google
    // click with a new Meta or newsletter campaign.
    var result = Object.keys(incoming).length ? incoming : saved;
    if (Object.keys(result).length) {
      try { sessionStorage.setItem(STORE, JSON.stringify(result)); } catch (_) {}
    }
    // Google's linker token is short-lived. Forward only the current URL's
    // token; never resurrect it from session storage.
    var linker = params.get('_gl');
    if (linker && linker.length <= 2048 && !/[\r\n<>@]/.test(linker)) result._gl = linker;
    return result;
  }
  function sync(event) {
    var detail = event && event.detail;
    if (detail && typeof detail.marketingAllowed === 'boolean' && typeof window._saunamoApplyCMP === 'function') {
      window._saunamoApplyCMP({
        m: !blocked() && detail.marketingAllowed,
        a: !blocked() && detail.analyticsAllowed === true
      });
    }
    read();
  }
  window.saunamoCampaignTracking = {allowed: allowed, read: read, blocked: blocked};
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('saunamo:consent-updated', sync);
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
  read();
})();
